var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.8C23.0692 28.8 28.8 23.0693 28.8 16C28.8 8.93077 23.0692 3.20001 16 3.20001C8.93075 3.20001 3.2 8.93077 3.2 16C3.2 23.0693 8.93075 28.8 16 28.8ZM21.9314 14.7314C22.5562 14.1065 22.5562 13.0935 21.9314 12.4686C21.3065 11.8438 20.2935 11.8438 19.6686 12.4686L14.4 17.7373L12.3314 15.6686C11.7065 15.0438 10.6935 15.0438 10.0686 15.6686C9.44379 16.2935 9.44379 17.3065 10.0686 17.9314L13.2686 21.1314C13.8935 21.7562 14.9065 21.7562 15.5314 21.1314L21.9314 14.7314Z",
    fill: "#56E099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c142b2ec3784166189c8c8b3102f9c15.svg";
export { ForwardRef as ReactComponent };